// Hosted preview page (storefront-plugin `dev/preview-host.html` → `/v1/preview.html`).
// Override with REACT_APP_PLUGIN_PREVIEW_URL, e.g. a locally served
// `storefront-plugin/dist/preview.html`, until the plugin host is live.
export const DEFAULT_PLUGIN_PREVIEW_URL = 'https://shopify.plugin.wallmates.com/v1/preview.html';

export const PLUGIN_PREVIEW_URL: string = process.env.REACT_APP_PLUGIN_PREVIEW_URL || DEFAULT_PLUGIN_PREVIEW_URL;

/** Brand feature flag gating the Settings → Storefront Plugin tab (order-handler STOREFRONT_PLUGIN_FLAG). */
export const STOREFRONT_PLUGIN_FLAG = 'storefront_plugin';

/**
 * Global feature flag (Development → Feature Flags) that shows the Storefront Plugin
 * tab for every brand at once. The tab shows when this OR the brand flag is on.
 */
export const STOREFRONT_PLUGIN_GLOBAL_FLAG = 'storefront-plugin';

/** Free trial length granted once per brand (order-handler PLUGIN_TRIAL_DAYS). */
export const PLUGIN_TRIAL_DAYS = 14;

// postMessage protocol (storefront-plugin `src/lib/preview.ts`).
export const PREVIEW_PORTAL_SOURCE = 'wallmates-portal';
export const PREVIEW_PLUGIN_SOURCE = 'wallmates-plugin';
export const PREVIEW_DATA = 'wm:preview-data';
export const PREVIEW_THEME = 'wm:preview-theme';
export const PREVIEW_READY = 'wm:preview-ready';
export const PREVIEW_ERROR = 'wm:preview-error';
